// extracted by mini-css-extract-plugin
export default {"cursorDot":"Cursor_cursorDot__aJSYj","cursorOutline":"Cursor_cursorOutline__lvV0a"};